var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-3"},[_c('div',{staticClass:"col-12 form-group"},[_c('p',{directives:[{name:"t",rawName:"v-t",value:('modulesForms._common.noForm'),expression:"'modulesForms._common.noForm'"}],staticClass:"mb-0"})])])}
var staticRenderFns = []

export { render, staticRenderFns }